<template>
    <component :is="parentWrapper" class="pa-0">
        <template v-if="active">
            <v-container px-3 py-0 grid-list-md white my-3 fluid>
                <v-layout row wrap>
                    <v-flex md6>
                        <p class="title mb-1">{{ 'Billing address' | translation }}</p>

                        <v-card :flat="flatCards">
                            <v-card-text class="pa-0">
                                <div>
                                    {{billingAddress ? billingAddress.firstName : ''}}
                                    {{billingAddress ? billingAddress.lastName : ''}}
                                </div>
                                <div>
                                    {{billingAddress ? billingAddress.street : ''}}
                                    {{billingAddress ? billingAddress.houseNumber : ''}}
                                </div>
                                <div>
                                    {{billingAddress ? billingAddress.postCode : ''}}
                                    {{billingAddress ? billingAddress.city : ''}}
                                </div>
                                <div>{{billingAddress ? $country.getCountryNameBy('iso_2', billingAddress.country) : '' | translation }}</div>
                                <div v-if="customerData.email">{{customerData.email}}</div>
                                <div v-else-if="registrationEmail">{{registrationEmail}}</div>
                            </v-card-text>

                            <v-card-actions class="px-0">
                                <a @click.prevent="onEditAddress(null)" href="#">{{ 'Change Address' | translation }}</a>
                            </v-card-actions>
                        </v-card>
                    </v-flex>

                    <v-flex md6>
                        <p class="title mb-1">{{ 'shipping address' | translation }}</p>

                        <v-card :flat="flatCards">
                            <v-card-text class="pa-0" v-if="shippingAddresses.length === 1 || !isUserLoggedIn">
                                <div>
                                    {{shippingAddress ? shippingAddress.firstName : ''}}
                                    {{shippingAddress ? shippingAddress.lastName : ''}}
                                </div>
                                <div>
                                    {{shippingAddress ? shippingAddress.street : ''}}
                                    {{shippingAddress ? shippingAddress.houseNumber : ''}}
                                </div>
                                <div>
                                    {{shippingAddress ? shippingAddress.postCode : ''}}
                                    {{shippingAddress ? shippingAddress.city:''}}
                                </div>
                                <div>{{ shippingAddress ? $country.getCountryNameBy('iso_2', shippingAddress.country) : '' | translation }}</div>
                                <div v-if="customerData.email">{{customerData.email}}</div>
                                <div v-else-if="registrationEmail">{{registrationEmail}}</div>
                            </v-card-text>

                            <v-card-text v-else>
                                <ShippingAddressRadioGroup :addresses="shippingAddresses" />
                            </v-card-text>

                            <v-card-actions class="px-0">
                                <a @click.prevent="onEditAddress(null)" href="#">{{ 'Change Address' | translation }}</a>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container grid-list-md white mt-3 pb-0 fluid :class="{'px-0': $vuetify.breakpoint.xsOnly}">
                <p class="title" v-if="displayLabel">
                    {{ 'shopping cart' | translation }}
                </p>

                <basket-items
                    :selectableShipping="false"
                    :coupon="$vuetify.breakpoint.mdAndUp"
                    shipping-provider-selection
                    :getPriceForAddress="true"
                    :flat-cards="flatCards"
                    :related-products-cols="relatedProductsCols"
                />
            </v-container>

            <v-container fluid grid-list-md white pt-0 v-if="shippingPrices && Object.values(shippingPrices).length">
                <v-layout row wrap>
                    <v-flex md6 offset-md6>
                        <v-card color="grey lighten-3">
                            <v-card-title class="pb-0">
                                <p class="title primary--text pa-0 mb-0">
                                    <v-icon color="primary">credit_card</v-icon>
                                    {{ 'payment method' | translation }}
                                </p>
                            </v-card-title>

                            <payment
                                v-if="active"
                                @success="$emit('onNextStep', $event)"
                                @received="$emit('onNextStep', {...$event, paid: false})"
                                @editAddress="onEditAddress"
                                :flat="flatCards"
                            />
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container fluid grid-list-md white mt-3 v-if="$vuetify.breakpoint.smAdnDown">
                <coupon button-color="default" />
            </v-container>

            <v-container fluid grid-list-md white mt-3>
                <v-sheet v-for="(merchantItems, merchantId) in $basket.getMerchantizedItems()" :key="merchantId">
                    <free-shipping-info
                        :merchantId="parseInt(merchantId)"
                        :merchantTotal="$basket.getMerchantTotal(merchantId)"
                        :cols="relatedProductsCols"
                    />
                </v-sheet>
            </v-container>
        </template>
    </component>
</template>

<script>
    import StepBase from '@breakmedia/prime-vue-stepper/src/StepBase';
    import ShippingAddressRadioGroup from '../AddressStep/ShippingAddressRadioGroup';
    import {mapState, mapGetters, mapActions} from 'vuex';
    import Login from '@breakmedia/prime-vue-customer/src/Login/LoginForm'
    import ShippingSelector from '@breakmedia/prime-vue-basket/src/ShippingSelector';

    export default {
        //do not set the name - it will break the integration with vuetify stepper
        extends: StepBase,
        components: {
            ShippingAddressRadioGroup
        },
        mounted() {
            if (this.$route.params.stepName === this.route) {
                // wait two ticks to make stepper configure steps events
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.loadCustomerData().then(() => {
                            let redirectToAddress = false;
                            if (this.isUserLoggedIn) {
                                if (!this.customerHasDSGVO) {
                                    redirectToAddress = true;
                                }
                            } else {
                                const agb = this.$session.get('agb');
                                if (!agb) {
                                    redirectToAddress = true;
                                }
                            }
                            if (redirectToAddress) {
                                this.$emit('goToStep', {
                                    route: 'address',
                                });
                            }
                        });
                    });
                });
            }
        },
        data() {
            return {
                products: [],
                merchantsData: {},
                listReady: false,
                selectedAddress: 0
            };
        },
        props: {
            displayLabel: true,
            route: {
                default: 'summary',
            },
            flatCards: Boolean,
            relatedProductsCols: {
                default: 2,
                type: Number,
            },
        },
        computed: {
            ...mapState('Customer', [
                'customerData',
                'customerHasDSGVO',
            ]),
            ...mapState(ShippingSelector.name, ['shippingPrices']),
            ...mapState('Registration', {
                registrationEmail: state => state.email,
            }),
            ...mapGetters(Login.name, [
                'isUserLoggedIn',
            ]),
            shippingAddresses() {
                return this.$order.getShippingAddresses();
            },
            billingAddress() {
                return this.$order.getBillingAddress();
            },
            shippingAddress() {
                return this.$order.getShippingAddress();
            },
        },
        methods: {
            ...mapActions('Customer', [
                'loadCustomerData',
            ]),
            ...mapActions('NotificationModal', [
                'displayNotificationModal',
            ]),
            onEditAddress(event) {
                const props = {};
                if (event) {
                    props.displayHouseNumberField = true;
                    props.displayBillingForm = true;
                    props.redirect = {
                        route: 'summary',
                    };
                    props.query = {
                        payment: event,
                    };
                }
                const nextStepProps = {
                    route: 'address',
                    props,
                };
                if (!this.isUserLoggedIn) {
                    nextStepProps.subStepName = 'guest-checkout';
                }
                this.$emit('goToStep', nextStepProps);
            },
        },
        watch: {
            isUserLoggedIn(newVal, oldVal) {
                if (
                    oldVal &&
                    !newVal &&
                    this.$route.name == 'checkout' &&
                    this.$route.params.stepName &&
                    this.$route.params.stepName == this.route
                ) {
                    this.displayNotificationModal({
                        message: this.$language.translate('CUSTOMER_LOGOUT_AT_SUMMARY_TEXT'),
                        closeButtonText: 'CUSTOMER_LOGOUT_AT_SUMMARY_BUTTON',
                        persistent: true,
                    });
                    this.$emit('goToStep', {
                        route: 'address',
                    });
                }
            }
        }
    };
</script>
